import React from 'react';
import ChatWidget from '../components/Chat/ChatWidget';
import { ChatProvider } from '../contexts/ChatContext';
import { ConversationProvider } from '../contexts/ConversationContext';

const ChatPage: React.FC = () => {
  return (
    <ConversationProvider>
      <ChatProvider>
        <ChatWidget />
      </ChatProvider>
    </ConversationProvider>
  );
};

export default ChatPage;
